// src/frontend/context/RoomContext.jsx
import {createContext, useContext, useEffect, useState} from 'react';
import {socket} from '../lib/socket';
import {SOCKET_EVENTS} from "../constants/events.js";
import toast from "react-hot-toast";

const RoomContext = createContext();

export function RoomProvider({children}) {
    const [roomId, setRoomId] = useState(null);
    const [username, setUsername] = useState('');
    const [users, setUsers] = useState([]);
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        if (!roomId) return;

        socket.connect();
        socket.emit(SOCKET_EVENTS.JOIN_ROOM, {roomId, username});

        socket.on(SOCKET_EVENTS.UPDATE_USERS, (userList) => {
            setUsers(userList);
            console.log('[ROOM] Updated users:', userList);  // ← Neuer Log für Debugging
        });
        socket.on('connect', () => setIsConnected(true));
        socket.on('disconnect', () => setIsConnected(false));

        return () => {
            socket.emit(SOCKET_EVENTS.LEAVE_ROOM, {roomId, username});
            socket.disconnect();
            toast('Raum verlassen', {icon: '👋'});
        };
    }, [roomId, username]);

    const leaveRoom = () => {
        // Bestehende Logik
        socket.emit(SOCKET_EVENTS.LEAVE_ROOM, {roomId, username});
        setRoomId(null);
        setUsername('');

        // NEU: URL-Parameter entfernen
        const newUrl = window.location.pathname; // Nur Pfad, keine Params
        window.history.replaceState({}, '', newUrl);
        console.log('[ROOM] URL bereinigt – kein Auto-Join mehr');
    };

    const joinRoom = (rid, uname) => {
        setRoomId(rid);
        setUsername(uname);

        // URL anpassen: nur ?room=... behalten, user entfernen
        const newUrl = `${window.location.pathname}?room=${encodeURIComponent(rid)}`;
        window.history.replaceState({}, '', newUrl);
        console.log('[ROOM] URL angepasst auf:', newUrl);

        socket.emit(SOCKET_EVENTS.JOIN_ROOM, {roomId: rid, username: uname});
    };

    return (
        <RoomContext.Provider value={{
            roomId, setRoomId,
            username, setUsername,
            users,
            isConnected,
            joinRoom,
            leaveRoom
        }}>
            {children}
        </RoomContext.Provider>
    );
}

export const useRoom = () => useContext(RoomContext);